import { render, staticRenderFns, recyclableRender, components } from "./order-confirm.vue?vue&type=template&id=8e121d12&scoped=true&"
var renderjs
import script from "./order-confirm.vue?vue&type=script&lang=js&"
export * from "./order-confirm.vue?vue&type=script&lang=js&"
import style0 from "./order-confirm.vue?vue&type=style&index=0&id=8e121d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e121d12",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uce-course/pages/detail/order-confirm.vue"
export default component.exports